import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../common/api";
import { Anchor, Group, MantineColor, MantineSize, Text } from "@mantine/core";
import RecordAvatar from "../common/RecordAvatar";
import { getUserLink } from "../../common/util";
import Link from "next/link";

const UserDisplay = ({
  user: userId,
  size,
  usfaMemberNumber,
  color,
  link,
  emailOnly,
}: {
  user: string;
  size?: MantineSize;
  usfaMemberNumber?: boolean;
  color?: "dimmed" | MantineColor;
  link?: boolean;
  emailOnly?: boolean;
}) => {
  const { data: user } = useQuery(["user", userId], () => getUser(userId));
  if (!user) return <></>;
  if (usfaMemberNumber)
    return (
      <Text color={color} size={size}>
        {user.usfaMemberNumber}
      </Text>
    );
  if (emailOnly) return <>{user.email}</>;
  const name = user.lastName ? `${user.name} ${user.lastName}` : user.name;
  const content = (
    <Group>
      <RecordAvatar record={user} size={size} />
      <Text color={color} size={size}>
        {name}
      </Text>
    </Group>
  );
  if (link) {
    return (
      <Anchor
        component={Link}
        href={getUserLink(user)}
        className="user-display"
      >
        {content}
      </Anchor>
    );
  }
  return content;
};
export default UserDisplay;
